import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Check, ArrowRight } from "lucide-react";
import { SectionHead } from "../components/Reveal";
import { SERVICES } from "../data/content";
import { SERVICE_IMGS } from "../data/images";

export default function Services() {
  return (
    <main className="pt-28">
      <section data-testid="services-page-section" className="section-pad !pt-8">
        <div className="container-x">
          <SectionHead badge="Our Services" title="Premium IT Services, Built Around You"
            sub="From a single API to a full digital transformation — one accountable partner for your entire technology stack." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Sparkles;
              return (
                <motion.article key={s.id} data-testid={`service-card-${s.id}`}
                  initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: (i % 3) * 0.08 }} whileHover={{ y: -8 }}
                  className="glass-card rounded-2xl overflow-hidden flex flex-col group">
                  <div className="relative h-36 overflow-hidden shrink-0">
                    <img src={SERVICE_IMGS[s.id]} alt={`${s.title} — VAELIX TECHNOLOGY`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-950/55 to-transparent" aria-hidden="true" />
                  </div>
                  <div className="p-7 pt-5 flex flex-col flex-1">
                  <span className="w-13 h-13 p-3 rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-500 text-white shadow-[0_8px_24px_rgba(99,102,241,0.4)] group-hover:scale-110 transition-transform duration-300">
                    <Icon size={26} />
                  </span>
                  <h2 className="mt-5 text-lg font-semibold tracking-tight">{s.title}</h2>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                  <ul className="mt-4 space-y-2 flex-1">
                    {s.benefits.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-muted-foreground">
                        <Check size={15} className="mt-0.5 text-cyan-400 shrink-0" /> {b}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contact" data-testid={`service-learn-more-${s.id}`}
                    className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:gap-3 transition-all duration-200">
                    Learn More <ArrowRight size={15} />
                  </Link>
                  </div>
                </motion.article>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
